import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';

let timer = null;

const ConfirmButton = ({
  children, confirmText, onClick, delayMs, 'data-testid': dataTestId, ...props
}) => {
  const [isConfirm, setIsConfirm] = useState(false);

  const properOnClick = (e) => {
    if (isConfirm) {
      onClick(e);
      clearTimeout(timer);
      setIsConfirm(false);
    } else {
      setIsConfirm(true);
      clearTimeout(timer);
      timer = setTimeout(() => {
        setIsConfirm(false);
      }, delayMs);
    }
  };

  return (
    <Button data-testid={dataTestId} {...props} onClick={properOnClick}>
      {isConfirm ? confirmText || 'Confirm' : children}
    </Button>
  );
};

ConfirmButton.propTypes = {
  'data-testid': PropTypes.string,
  onClick      : PropTypes.func.isRequired,
  children     : PropTypes.node.isRequired,
  confirmText  : PropTypes.string,
  delayMs      : PropTypes.number,
};

ConfirmButton.defaultProps = {
  'data-testid': undefined,
  confirmText  : null,
  delayMs      : 3000,
};

export default ConfirmButton;
